class OkendoAttributeRating extends HTMLElement {
  constructor() {
    super();
  }

  selectors = {
    label: {
      min: "[data-attribute-rating-widget-label-min]",
      mid: "[data-attribute-rating-widget-label-mid]",
      max: "[data-attribute-rating-widget-label-max]"
    },
    value: "[data-attribute-rating-widget-value]"
  };

  modifiers = {
    hidden: "hidden"
  };

  attributes = {
    productId: "product-id"
  };

  get productId() {
    return this.getAttribute(this.attributes.productId);
  }

  get okendoUserId() {
    return theme.okendo_user_id;
  }

  get okendoAttributeRatingType() {
    return "centered-range";
  }

  async connectedCallback() {
    const url = `https://api.okendo.io/v1/stores/${this.okendoUserId}/products/shopify-${this.productId}/review_aggregate`;

    const response = await fetch(url);
    const data = await response.json();

    const { reviewAggregate } = data;
    const { attributeRatings } = reviewAggregate || {};

    if (!attributeRatings || !attributeRatings.length) {
      return;
    }

    const [attributeRating] = attributeRatings;
    const { type, value, minLabel, midLabel, maxLabel } = attributeRating;

    if (type !== this.okendoAttributeRatingType) {
      return;
    }

    this.buildWidget(value, minLabel, midLabel, maxLabel);

    this.classList.remove(this.modifiers.hidden);
  }

  buildWidget(value, minLabel, midLabel, maxLabel) {
    const labelMinElement = this.querySelector(this.selectors.label.min);
    const labelMidElement = this.querySelector(this.selectors.label.mid);
    const labelMaxElement = this.querySelector(this.selectors.label.max);

    const valueElement = this.querySelector(this.selectors.value);

    labelMinElement.innerText = minLabel;
    labelMidElement.innerText = midLabel;
    labelMaxElement.innerText = maxLabel;

    valueElement.style.left = `calc(50% + ${(value / 2 * 100)}%)`;
  }
}

if (!customElements.get("okendo-attribute-rating")) {
  customElements.define("okendo-attribute-rating", OkendoAttributeRating);
}
